import { AHIcon, Box, ColorType, useLayoutContext } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { Image } from "expo-image";
import {
  LinkedItemContainer,
  LinkedItemSubtitle,
  LinkedItemTitle,
} from "./LinkedItemContainer";
import { LinkedWorkspaceProductItem_WorkspaceProduct$key } from "./__generated__/LinkedWorkspaceProductItem_WorkspaceProduct.graphql";

export function LinkedWorkspaceProductItem(props: {
  product: LinkedWorkspaceProductItem_WorkspaceProduct$key;
  unLinkProduct?: (id: string) => void;
  onPressProduct: (id: string) => void;
  borderColor?: ColorType;
  disabled?: boolean;
}) {
  const layout = useLayoutContext();
  const product = useFragment(
    graphql`
      fragment LinkedWorkspaceProductItem_WorkspaceProduct on WorkspaceProduct {
        id
        imageUrl
        partNumber
        name
      }
    `,
    props.product
  );
  return (
    <LinkedItemContainer
      disabled={props.disabled}
      onPress={() => {
        props.onPressProduct(product.id);
      }}
      onRemove={
        props.unLinkProduct
          ? () => {
              props.unLinkProduct?.(product.id);
            }
          : undefined
      }
      borderColor={props.borderColor}
    >
      <AHIcon type="product" color="text-secondary" spaceRight="small" />
      <Box style={{ flex: 1 }} spaceRight="small">
        <LinkedItemTitle>{product.name}</LinkedItemTitle>
        <LinkedItemSubtitle>{product.partNumber}</LinkedItemSubtitle>
      </Box>
      {product.imageUrl ? (
        <Box>
          <Image
            source={{ uri: product.imageUrl }}
            contentFit="contain"
            style={{
              height: layout.circle.medium,
              width: layout.circle.medium,
            }}
          />
        </Box>
      ) : null}
    </LinkedItemContainer>
  );
}
